import React from 'react';
import { oohData } from '../utils/oohData';
import { CheckIcon, ArrowRightIcon, EyeIcon, FlaskConicalIcon } from 'lucide-react';
export const AttentionTestingCTA: React.FC = () => {
  const {
    attentionTesting,
    methodology
  } = oohData;
  return <div className="space-y-4" data-id="element-76" data-mp="c8hk3qokrolh">
      {/* Observation framing — sets up why testing is the next step */}
      <div className="bg-white rounded-xl shadow-sm p-6 flex items-start space-x-3" data-id="element-77" data-mp="79emgraxcknj">
        <div className="p-2 bg-gray-100 text-gray-500 rounded-lg flex-shrink-0" data-id="element-78" data-mp="3b78u5brbzgk">
          <EyeIcon className="w-5 h-5" data-id="element-79" data-mp="3ufdxev4sysw0" />
        </div>
        <p className="text-sm text-gray-600 leading-relaxed" data-id="element-80" data-mp="3pgubuvu4fj46">
          {methodology.observationNote}
        </p>
      </div>

      {/* The upsell / link to Attention Testing */}
      <div className="bg-[#1E90FF] rounded-xl shadow-sm p-8 text-white" data-id="element-81" data-mp="3kkdrmcq1lowd">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8" data-id="element-82" data-mp="1np7l8ve55q88">
          <div className="flex-1" data-id="element-83" data-mp="1irpl9ui3qlcd">
            <div className="flex items-center space-x-2 mb-3" data-id="element-84" data-mp="1iojso5a9l1bw">
              <FlaskConicalIcon className="export-icon-down w-5 h-5 text-white/90" data-id="element-85" data-mp="1nyfbq729lt8j" />
              <span className="text-xs font-semibold uppercase tracking-wider text-white/90" data-id="element-86" data-mp="1sytn9z32rlbb">
                {attentionTesting.eyebrow}
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-semibold leading-tight mb-3" data-id="element-87" data-mp="1j0drvjx0lpw0">
              {attentionTesting.heading}
            </h3>
            <p className="text-sm text-white/85 leading-relaxed mb-5 max-w-2xl" data-id="element-88" data-mp="26r9iwetnch27">
              {attentionTesting.body}
            </p>
            <ul className="space-y-2" data-id="element-89" data-mp="2br47gbpy8uk3">
              {attentionTesting.bullets.map((bullet, idx) => <li key={idx} className="flex items-start space-x-2.5" data-id="element-90" data-mp="1wyatiuqbsmhj" data-mpi={idx}>
                  <span className="mt-0.5 flex-shrink-0 flex items-center justify-center w-4 h-4 rounded-full bg-white/20" data-id="element-91" data-mp="21xngrgl3zvkn">
                    <CheckIcon className="w-3 h-3" data-id="element-92" data-mp="2pmzn88p1xpj9" />
                  </span>
                  <span className="text-sm text-white/90 leading-relaxed" data-id="element-93" data-mp="2ugu3111jdkd2">
                    {bullet}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="lg:flex-shrink-0" data-id="element-94" data-mp="2zcy87rn5df6c">
            <a href={attentionTesting.ctaHref} target="_blank" rel="noopener noreferrer" data-export-hide className="inline-flex items-center justify-center space-x-2 bg-white text-[#1E90FF] px-6 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors whitespace-nowrap" data-id="element-95" data-mp="2val2324hnf91">
              <span data-id="element-96" data-mp="2gju7jmbii228">{attentionTesting.ctaLabel}</span>
              <ArrowRightIcon className="w-4 h-4" data-id="element-97" data-mp="2bm2kb5ltb44d" />
            </a>
          </div>
        </div>
      </div>
    </div>;
};